export default {
  namespaced: true,
  billing_price: {
    title: "Preços",
    region: "Região",
    security_company: "Empresa de Segurança",
    description: "Descrição",
    profile: "Perfil",
    hours: "Horas",
    days: "Dias",
    cost_per_hour: "Custo por Hora",
    cost_per_shift: "Custo por Turno",
  }
}